import React from "react"
import { Marker } from "@react-google-maps/api"
export default function PinMarker({
  latitude: lat,
  longitude: lng,
  title = undefined,
  onClick = undefined,
  ...otherProps
}) {
  return (
    <Marker
      onClick={onClick}
      animation={window.google.maps.Animation.DROP}
      title={title}
      position={{ lat, lng }}
      icon="https://cdn.vesatogo.com/images/pin-marker.png"
      {...otherProps}
    />
  )
}
